import type { FaireProductEntity } from "../../entity_types/product";

export const p_5wzhpg3fbg: FaireProductEntity = {
  token: "p_5wzhpg3fbg",
  type: "product",
  name: "Lotion Bar | Solid Moisturizer in Plastic-Free Refillable Tin",
  brandToken: "b_34jwv28ejh",
  brandName: "Zerra & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/cafebde5b0ea635cd3ac2f5b0096e16a0357fe39f24a685391170d99c9f1fc2d.jpeg",
  galleryImageUrls: [],
  priceDollars: 13,
  description:
    "Want to try a free sample? Send us a message!\n\nMeet our waterless and plastic free Lotion Bars! Packaged in a reusable metal tin with a paper band these lotion bars are a great zero waste swap for traditional liquid lotion. Each bar replaces up to 32 fl oz of liquid lotion.\n\nThese are a fantastic stocking stuffer and are a fall/winter skin care staple!\n\nOur bars are mostly shea butter for deep, nourishing hydration with mango butter for a touch of luxury hydration. Cetyl alcohol gives this bar a silky application while triglycerides (aka MCT oil) keep it light and non-greasy. Together they make a bar that gives rich hydration without the heavy, greasy feel most lotion bars and body salves have.\n\nTo use warm in hands for a few seconds and then apply. Melts with body heat, and stays solid up to 95-100 F.\n\nKey Features\n- Vegan and Cruelty Free\n- Coconut Free\n- Synthetic Fragrance Free\n\nNet Cont 2.3 oz (65 g)",
  tags: [],
  msrpDollars: 26,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:21.112Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
